import { action, Action, persist } from 'easy-peasy';

export interface PreferencesModel {
  v2OrdersEnabled: boolean;
  v2RoutesEnabled: boolean;
  alertDismissed: boolean;
  setV2OrdersEnabled: Action<PreferencesModel, boolean>;
  setV2RoutesEnabled: Action<PreferencesModel, boolean>;
  setAlertDismissed: Action<PreferencesModel, boolean>;
}

const preferencesModel: PreferencesModel = {
  v2OrdersEnabled: true,
  v2RoutesEnabled: true,
  alertDismissed: false,
  setV2OrdersEnabled: action((state, payload) => {
    state.v2OrdersEnabled = payload;
  }),
  setV2RoutesEnabled: action((state, payload) => {
    state.v2RoutesEnabled = payload;
  }),
  setAlertDismissed: action((state, payload) => {
    state.alertDismissed = payload;
  }),
};

export default persist(preferencesModel, {
  allow: ['v2OrdersEnabled', 'v2RoutesEnabled', 'alertDismissed'],
  storage: 'localStorage',
});
